import React, { FC, ReactNode } from 'react';
import { Stack } from '@mui/material';
import FiltersButton from '../FiltersButton';

type FinancialFrameToolbarProps = {
  children?: ReactNode;
  setFilterAnchorEl: (el: HTMLElement | null) => void;
};

const FinancialFrameToolbar: FC<FinancialFrameToolbarProps> = ({
  children,
  setFilterAnchorEl,
}) => (
  <Stack direction="row" gap={2} mb={2}>
    {children}
    <FiltersButton setFilterAnchorEl={setFilterAnchorEl} />
  </Stack>
);

export default FinancialFrameToolbar;
